'use strict';

var React = require('react');

var SvgTextGrammarIcon = function SvgTextGrammarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.695 3.717a.75.75 0 0 0-1.39 0l-2.75 6.75a.75.75 0 0 0 1.39.566l.624-1.533h2.681c.06 0 .117-.007.173-.02l.632 1.553a.75.75 0 1 0 1.39-.566l-2.75-6.75Zm-.695 2.27.82 2.013h-1.64l.82-2.012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.25a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5h-10a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.75a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.5 5.5c.574 0 1.11.161 1.566.44a.75.75 0 0 1 1.434.31v4.5a.75.75 0 0 1-1.434.31 3 3 0 1 1-1.566-5.56Zm1.5 3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.78 14.28a.75.75 0 1 0-1.06-1.06l-2.97 2.97-1.22-1.22a.75.75 0 1 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l3.5-3.5Z"
  }));
};
SvgTextGrammarIcon.displayName = "TextGrammarIcon";

exports.SvgTextGrammarIcon = SvgTextGrammarIcon;
